(function(){
  'use strict';
  var TH = window.TH || {};

  // ---- Para biçimi (dile göre) ----
  function para(kurus){
    var dil = TH.locale || 'en', x = (kurus||0)/100, loc = {tr:'tr-TR',de:'de-DE',fr:'fr-FR',ar:'en-US',en:'en-US'}[dil] || 'en-US';
    return x.toLocaleString(loc,{minimumFractionDigits:2,maximumFractionDigits:2}) + ' TL';
  }
  TH.para = para;

  // ---- Galeri ----
  var gal = document.querySelector('[data-gal]');
  if (gal) {
    var resimler = [].slice.call(gal.querySelectorAll('.gal__img'));
    var kucukler = [].slice.call(gal.querySelectorAll('[data-kucuk]'));
    var say = gal.querySelector('[data-say]'), aktif = 0;
    var galGit = function(n){
      if (!resimler.length) return;
      aktif = (n + resimler.length) % resimler.length;
      resimler.forEach(function(r,i){ r.classList.toggle('on', i === aktif); });
      kucukler.forEach(function(k,i){ k.classList.toggle('on', i === aktif); });
      if (say) say.textContent = (aktif+1) + ' / ' + resimler.length;
      var k = kucukler[aktif]; if (k && k.parentNode && k.parentNode.scrollTo) { k.parentNode.scrollTo({left: k.offsetLeft - 40, behavior: 'smooth'}); }
    };
    kucukler.forEach(function(k,i){ k.addEventListener('click', function(){ galGit(i); }); });
    gal.querySelectorAll('[data-yon]').forEach(function(b){ b.addEventListener('click', function(){ var y = +b.dataset.yon; if (document.dir === 'rtl') y = -y; galGit(aktif + y); }); });
    var bx = null, ana = gal.querySelector('.gal__ana');
    ana.addEventListener('touchstart', function(e){ bx = e.touches[0].clientX; }, {passive:true});
    ana.addEventListener('touchend', function(e){ if (bx === null) return; var d = e.changedTouches[0].clientX - bx; if (Math.abs(d) > 40) galGit(aktif + (d < 0 ? 1 : -1)); bx = null; }, {passive:true});
    galGit(0);
    TH.galeriMedya = function(mediaId){ var i = resimler.findIndex(function(r){ return r.dataset.mediaId == String(mediaId); }); if (i > -1) galGit(i); };
  }

  // ---- Satın alma kutusu ----
  // Kampanya: 2'li ve 3'lü paketlerin sabit toplam fiyatı (data-p2 / data-p3, kuruş)
  var kutu = document.querySelector('[data-kutu]');
  if (kutu) {
    var veri = JSON.parse(kutu.querySelector('[data-urun-json]').textContent);
    var pk2 = +kutu.dataset.p2 || 0, pk3 = +kutu.dataset.p3 || 0;
    var renkKutu = kutu.querySelector('[data-renk]');
    var adet = 1, secim = [0,0,0];
    var renkler = veri.renkler;
    var ekKutu = kutu.querySelector('[data-ekler]');
    function ekSecili(){
      if (!ekKutu) return [];
      return [].slice.call(ekKutu.querySelectorAll('[data-ek]')).filter(function(l){ return l.querySelector('[data-ek-kutu]').checked; }).map(function(l){
        var sec = l.querySelector('[data-ek-sec]'), cb = l.querySelector('[data-ek-kutu]');
        var sonuc;
        if (sec) { var o = sec.options[sec.selectedIndex]; sonuc = {id:+o.value, fiyat:+o.dataset.fiyat}; }
        else { sonuc = {id:+cb.value, fiyat:+cb.dataset.fiyat}; }
        var notKutu = l.nextElementSibling && l.nextElementSibling.matches('[data-ek-not]') ? l.nextElementSibling : null;
        if (notKutu) { var nt = notKutu.querySelector('[data-ek-not-metin]').value.trim(); if (nt) sonuc.properties = {'Hediye notu': nt}; }
        return sonuc;
      });
    }
    function ekToplam(){ return ekSecili().reduce(function(a,e){ return a + e.fiyat; }, 0); }
    if (ekKutu) {
      ekKutu.addEventListener('change', function(e){
        var l = e.target.closest('[data-ek]'); if (!l) return;
        if (e.target.matches('[data-ek-sec]')) { l.querySelector('[data-ek-kutu]').checked = true; }
        l.classList.toggle('on', l.querySelector('[data-ek-kutu]').checked);
        var nk = l.nextElementSibling; if (nk && nk.matches('[data-ek-not]')) nk.hidden = !l.querySelector('[data-ek-kutu]').checked;
        ciz();
      });
    }
    function toplam(n){
      var fiyatlar = []; for (var k=0;k<n;k++){ fiyatlar.push(renkler[secim[k]].fiyat); }
      var t = fiyatlar.reduce(function(a,b){return a+b;},0), ind = 0;
      if (n === 3 && pk3) { ind = Math.max(0, t - pk3); }
      else if (n === 2 && pk2) { ind = Math.max(0, t - pk2); }
      return {t:t-ind+ekToplam(), liste:t, ind:ind};
    }
    function ciz(){
      var h = '';
      if (renkler.length > 1) {
        for (var k=0;k<adet;k++){
          var baslik = adet > 1 ? veri.t.bant.replace('%n', k+1) : veri.t.renk;
          h += '<div class="renk__satir"><span class="renk__et">' + baslik + ': <span>' + renkler[secim[k]].etiket + '</span></span><span class="renk__sec" role="group">';
          renkler.forEach(function(r,j){ var gorsel = r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="44" height="44">' : ''; h += '<button type="button" class="renk__btn' + (r.img ? ' renk__btn--g' : '') + (secim[k]===j?' on':'') + '" data-k="'+k+'" data-j="'+j+'" aria-pressed="' + (secim[k]===j) + '" title="' + r.etiket + '">' + gorsel + '<i style="background:' + r.kod + '"></i><span>' + r.etiket + '</span></button>'; });
          h += '</span></div>';
        }
      }
      renkKutu.innerHTML = h; renkKutu.hidden = !h;
      var s = toplam(adet), yazi = para(s.t);
      kutu.querySelectorAll('[data-toplam]').forEach(function(e){ e.textContent = yazi; });
      var cta = kutu.querySelector('[data-cta-tutar]'); if (cta) cta.textContent = '· ' + yazi;
      var ab = document.querySelector('[data-altbar-fiyat]'); if (ab) ab.textContent = yazi;
      var tekRenk = true; for (var i=1;i<adet;i++){ if (secim[i] !== secim[0]) tekRenk = false; }
      kutu.querySelector('[data-form-id]').value = renkler[secim[0]].variantId;
      kutu.querySelector('[data-form-adet]').value = adet;
      kutu.dataset.tekRenk = tekRenk ? '1' : '0';
    }
    renkKutu.addEventListener('click', function(e){
      var b = e.target.closest('.renk__btn'); if (!b) return;
      secim[+b.dataset.k] = +b.dataset.j; ciz();
      var r = renkler[+b.dataset.j]; if (r.mediaId && TH.galeriMedya) TH.galeriMedya(r.mediaId);
    });
    kutu.querySelectorAll('.paket input').forEach(function(inp){
      inp.addEventListener('change', function(){
        kutu.querySelectorAll('.paket').forEach(function(p){ p.classList.toggle('on', p.contains(inp)); });
        adet = +inp.value; ciz();
      });
    });
    var form = kutu.querySelector('form[data-urun-form]');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[data-cta]'), hata = kutu.querySelector('[data-form-hata]');
      var sayac = {}; for (var k=0;k<adet;k++){ var id = renkler[secim[k]].variantId; sayac[id] = (sayac[id]||0) + 1; }
      var items = Object.keys(sayac).map(function(id){ return {id:+id, quantity:sayac[id]}; });
      ekSecili().forEach(function(e){ var it = {id:e.id, quantity:1}; if (e.properties) it.properties = e.properties; items.push(it); });
      btn.disabled = true; if (hata) hata.style.display = 'none';
      fetch(TH.cartAdd, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:items})})
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(){ btn.disabled = false; if (TH.cekmece) { TH.cekmece.ac(); } else { window.location.href = TH.cart; } })
        .catch(function(){ btn.disabled = false; if (hata) { hata.textContent = TH.t.hata; hata.style.display = 'block'; } });
    });
    ciz();
  }

  // ---- Video slider: yalnızca görünen video oynar ----
  document.querySelectorAll('[data-vid]').forEach(function(v){
    var ray = v.querySelector('.vid__ray'); if (!ray) return;
    var kartlar = [].slice.call(ray.children), nokta = v.querySelector('.vid__nokta');
    kartlar.forEach(function(k,n){ var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (n+1)); b.addEventListener('click', function(){ git(n); }); nokta.appendChild(b); });
    function x(k){ return Math.abs(k.offsetLeft - ray.offsetLeft); }
    function git(n){ n = Math.max(0, Math.min(kartlar.length-1, n)); var hedef = kartlar[n].offsetLeft - ray.offsetLeft; ray.scrollTo({left: document.dir === 'rtl' ? -Math.abs(hedef) : hedef, behavior:'smooth'}); }
    function aktif(){
      var sl = Math.abs(ray.scrollLeft), g = ray.clientWidth, ilk = 0, m = 1e9;
      kartlar.forEach(function(k,n){ var d = Math.abs(x(k) - sl); if (d < m){ m = d; ilk = n; } });
      var r = ray.getBoundingClientRect(), gorunur = r.top < innerHeight && r.bottom > 0 && !document.hidden;
      kartlar.forEach(function(k){ var vid = k.querySelector('video'); if (!vid) return; var px = x(k) - sl, ic = px > -k.offsetWidth/2 && px < g - k.offsetWidth/2;
        if (ic && gorunur) { var p = vid.play(); if (p && p.catch) p.catch(function(){}); } else { vid.pause(); } });
      [].forEach.call(nokta.children, function(b,n){ b.classList.toggle('on', n === ilk); });
      return ilk;
    }
    v.querySelectorAll('.vid__ok').forEach(function(o){ o.addEventListener('click', function(){ git(aktif() + (+o.dataset.yon)); }); });
    var t; ray.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(aktif, 120); }, {passive:true});
    addEventListener('scroll', aktif, {passive:true}); document.addEventListener('visibilitychange', aktif); aktif();
  });

  // ---- Mobil alt bar ----
  var bar = document.querySelector('[data-altbar]'), anaCta = document.querySelector('[data-cta]');
  if (bar && anaCta) {
    var kontrol = function(){ var r = anaCta.getBoundingClientRect(); bar.classList.toggle('goster', r.bottom < 0); };
    addEventListener('scroll', kontrol, {passive:true}); kontrol();
  } else if (bar) { bar.remove(); }
})();
